import MixpanelSettings from '@/modules/integrations/types/mixpanel/MixpanelSettings'
import MixpanelOverview from '@/modules/integrations/types/mixpanel/MixpanelOverview'

export default Object.freeze({
  type: 'mixpanel',
  title: 'Integrations_Mixpanel',
  category: 'Integrations_Mixpanel_Category',
  description: 'Integrations_Mixpanel_Description',
  image: require('@/img/integrations/mixpanel.png'),
  requiresAdmin: false,
  components: {
    settings: MixpanelSettings,
    overview: MixpanelOverview
  },
  urls: {
    guide: 'https://docs.xtremepush.com/docs/mixpanel'
  }
})



// WEBPACK FOOTER //
// ./src/modules/integrations/types/mixpanel/index.js